// TodoForm.jsx
import React, { useState } from 'react';

/**
 * Erweitertes Formular zum Hinzufügen von Aufgaben.
 * @param {Function} onAddTask - Funktion zum Speichern der Aufgabe.
 * @param {React.RefObject} inputRef - Referenz für das Eingabefeld zum externen Fokussieren.
 */
function TodoForm({ onAddTask, inputRef }) { 
  const [taskText, setTaskText] = useState('');
  const [priority, setPriority] = useState('Normal'); 

  const handleSubmit = (e) => {
    e.preventDefault(); 
    
    if (taskText.trim() === '') {
      return; 
    }

    // Übergibt Text und Priorität an die handleAddTask-Funktion in TodoListApp
    onAddTask(taskText.trim(), priority);

    // Zurücksetzen der lokalen Status-Werte
    setTaskText('');
    setPriority('Normal'); 
  };

  return (
    <form onSubmit={handleSubmit} className="add-todo-form-container">
      <div className="add-todo-inputs-group">
        <input
          ref={inputRef} // Verknüpfung der Ref für die FAB-Fokus-Funktion
          type="text"
          placeholder="Neue Aufgabe eingeben..."
          value={taskText}
          onChange={(e) => setTaskText(e.target.value)} 
          className="todo-input"
        />
        
        {/* Dropdown zur Auswahl der Priorität */}
        <select
          value={priority}
          onChange={(e) => setPriority(e.target.value)} 
          className="priority-select"
        >
          <option value="Low">Low</option>
          <option value="Normal">Normal</option>
          <option value="High">High</option>
        </select>
      </div>
      <button type="submit" className="add-button">
        Aufgabe hinzufügen
      </button>
    </form>
  );
}

export default TodoForm;